module.exports = __webpack_public_path__ + "static/media/editIconDots.07f82ea0.svg";